import { useConnectionTypeOnChangeCallbacks } from './hooks/useConnectionTypeOnChangeCallbacks'
import LanIcon from './parts/LanIcon'
import RadioItem from './parts/RadioItem'
import { ConnectionSupport } from '@/features/print/connectionSupport'
import { ConnectionType, connectionTypes as allConnectionTypes } from '@/features/print/constants'
import { useConnectionTypeField } from '@/features/settings/components/AddPrinterModal/form'
import PrinterIcon from '@/features/ui/icons/components/PrinterIcon'
import Typography from '@/features/ui/typography'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View } from 'react-native'

const SunmiDefaultIcon = () => <PrinterIcon width={20} height={20} />

interface ConnectionTypeRadioGroupProps {
    connectionTypes: ConnectionType[]
}

const ConnectionTypeRadioGroup: FC<ConnectionTypeRadioGroupProps> = ({ connectionTypes }) => {
    const { t } = useTranslation()

    const [fieldValue, fieldOnChange] = useConnectionTypeField()
    const onChangeCallbacks = useConnectionTypeOnChangeCallbacks(allConnectionTypes, fieldOnChange)

    return (
        <View style={styles.container}>
            <Typography.Heading variant="h5">
                {t('settings.printers.addPrinterModal.field.connectionType.label')}
            </Typography.Heading>
            <View style={styles.radioGroup}>
                {connectionTypes.includes(ConnectionType.SunmiDefault) && (
                    <RadioItem
                        label={t(
                            'settings.printers.addPrinterModal.field.connectionType.options.sunmiDefault'
                        )}
                        LabelIcon={SunmiDefaultIcon}
                        checked={fieldValue === ConnectionType.SunmiDefault}
                        onChange={onChangeCallbacks[ConnectionType.SunmiDefault]}
                    />
                )}
                {connectionTypes.includes(ConnectionType.Network) && (
                    <RadioItem
                        label={t(
                            'settings.printers.addPrinterModal.field.connectionType.options.network'
                        )}
                        LabelIcon={LanIcon}
                        checked={fieldValue === ConnectionType.Network}
                        onChange={onChangeCallbacks[ConnectionType.Network]}
                        disabled={
                            !ConnectionSupport.isSupportedConnectionType(ConnectionType.Network)
                        }
                    />
                )}
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        gap: 12,
    },
    radioGroup: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 24,
    },
})

export default ConnectionTypeRadioGroup
